import Vue from "vue";
import Router from "vue-router";

import app_index from "@/app/index";
import app_routes from "./app";

import pc_index from "@/pc/index";
import pc_routes from "./pc";

Vue.use(Router);

var sUserAgent = navigator.userAgent.toLowerCase();
var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
var bIsMidp = sUserAgent.match(/midp/i) == "midp";
var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
var bIsAndroid = sUserAgent.match(/android/i) == "android";
var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

// 预览问卷问题
/* console.log(window.location)
console.log(window.location.href.includes('/project/form/view')) */

if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
	console.log('phone')
	window.name = 'app'
	window.path = '/'
	window.component = app_index
	window.children = app_routes
} else if(window.location.href.includes('/project/form/view')){
	console.log('iframe')
	window.name = 'app'
	window.path = '/'
	window.component = app_index
	window.children = app_routes
}else if(window.location.href.includes('/s')){
	console.log('填写问卷')
	window.name = 'app'
	window.path = '/'
	window.component = app_index
	window.children = app_routes
}
else {
	console.log('pc')
	window.name = 'pc'
	window.path = '/'
	window.component = pc_index
	window.children = pc_routes
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
};

export default new Router({
	mode: "history",
	routes: [
		{
			name: window.name,
			path: window.path,
			component: window.component,
			children: window.children
		}
		// {
		// 	name: 'pc',
		// 	path: '/',
		// 	component: pc_index,
		// 	children: pc_routes,
		// },
		// {
		// 	name: 'app',
		// 	path: '/',
		// 	component: app_index,
		// 	children: app_routes,
		// },
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js